// @flow

export const defaultCookieOptions = (protocol: string): Object => ({
  secure: true,
  path: '/',
  sameSite: 'none',
})
